import { render, staticRenderFns } from "./AssessmentFooter.vue?vue&type=template&id=2126270c&scoped=true&"
import script from "./AssessmentFooter.vue?vue&type=script&lang=ts&"
export * from "./AssessmentFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentFooter.vue?vue&type=style&index=0&id=2126270c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126270c",
  null
  
)

export default component.exports